import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB1G6B9W9xcy_oYPsRCDV_DCV7Q3BFSgNA",
  authDomain: "mallugermantalk.firebaseapp.com",
  projectId: "mallugermantalk",
  storageBucket: "mallugermantalk.firebasestorage.app",
  messagingSenderId: "879816418174",
  appId: "1:879816418174:web:d7adc5bbf2410ccdfd492f"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);